import { useState, useEffect, useCallback } from 'react';
import api from "@/utils/connector/ApiConnector";
import { useUser } from '@/utils/userContext/UserContext';
import { CustomerDto } from '@/pages/Dashboard/Clientes/dto/ImportCoworkingCustomerRow';

type InconsistenceReponse = {
  coworkingId: string;
  hasInconsistency: boolean;
  customersWithoutSubscriptions?: CustomerDto[];
  customersWithInvalidEmails?: CustomerDto[];
};

export const useDataInconsistency = () => {
  const [customersWithoutSub, setCustomersWithoutSub] = useState<CustomerDto[]>([]);
  const [customersWithInvalidEmails, setCustomersWithInvalidEmails] = useState<CustomerDto[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userData } = useUser();

  const checkDataInconsistency = useCallback(async () => {
    if (!userData?.coworkingId) return;

    try {
      const response = await api.get<InconsistenceReponse>(`/coworking/${userData.coworkingId}/data-check`);
      if (response && response.hasInconsistency) {
        if (response.customersWithoutSubscriptions && response.customersWithoutSubscriptions.length > 0) {
          setCustomersWithoutSub(response.customersWithoutSubscriptions);
        }
        if (response.customersWithInvalidEmails && response.customersWithInvalidEmails.length > 0) {
          setCustomersWithInvalidEmails(response.customersWithInvalidEmails);
        }
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Erro ao verificar a consistência dos dados:', error);
    }
  }, [userData?.coworkingId]);

  useEffect(() => {
    // This check will run once when the hook is mounted.
    // It can be triggered from a login effect.
  }, [checkDataInconsistency]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    handleCloseModal,
    customersWithoutSub,
    customersWithInvalidEmails,
    checkDataInconsistency,
  };
};
